export const timeZoneData = [
  { value: 'America/Belem', label: 'PA, AM' },
  { value: 'America/Recife', label: 'MA, PI, CE, RN, PB' },
  { value: 'America/Recife', label: 'PE' },
  { value: 'America/Araguaina', label: 'TO' },
  { value: 'America/Maceio', label: 'AL, SE' },
  { value: 'America/Bahia', label: 'BA' },
  { value: 'America/Sao_Paulo', label: 'GO, DF, MG, ES, RJ, SP, PR, SC, RS' },
  { value: 'America/Campo_Grande', label: 'MS' },
  { value: 'America/Cuiaba', label: 'MT' },
  { value: 'America/Porto_Velho', label: 'RO' },
  { value: 'America/Boa_Vista', label: 'RR' },
];

export const deliveryTypesDataOld = [
  { value: '1', label: 'Apenas retiradas na loja' },
  { value: '2', label: 'Apenas entregas' },
  { value: '3', label: 'Retiradas e entregas' },
  { value: '4', label: 'Apenas visualização' },
  { value: '5', label: 'Apenas Agendamentos' },
  { value: '6', label: 'Retiradas/entregas e Agendamentos' },
];

export const deliveryTypesData = [
  { value: '1', label: 'Retiradas na loja' },
  { value: '2', label: 'Entrega' },
  { value: '3', label: 'Agendamento (entrega)' },
  { value: '4', label: 'Agendamento (retirada)' },
  { value: '5', label: 'Consumir no local' },
  { value: '6', label: 'Apenas visualização' },
];

export const orderByTypesData = [
  { value: 0, label: 'Sequencia' },
  { value: 1, label: 'Ordem Alfabética' },
  { value: 2, label: 'Maior Valor' },
  { value: 3, label: 'Menor Valor' },
];

export const layoutSelectData = [
  { label: 'Modelo 1', value: 0 },
  { label: 'Modelo 2', value: 1 },
  { label: 'Modelo 3 (Tablet)', value: 2 },
];

export const songSelectData = [
  { label: 'Som 1', value: 1 },
  { label: 'Som 2', value: 2 },
  { label: 'Som 3', value: 3 },
  { label: 'Som 4', value: 4 },
  { label: 'Som 5', value: 5 },
];

export const defaultConfigState = {
  existe: true,
  idConfig: '',
  tiposEntrega: '',
  cobrarMaior: 1,
  freteGratis: '',
  bloquearObs: 'False',
  mensagemObs: '',
  mensagem: '',
  vendaLojaFechada: 'False',
  mensagemVendaLojaFechada: '',
  faceBookPixel: '',
  googleTagManager: '',
  mostrarCategoriasInicio: 1,
  mostrarPromocoesInicio: 1,
  vendaSemAutenticacao: 0,
  vendaBloqueadaCartaoLivre: 0,
  localEntrega: 0,
  retirarTotalizador: false,
  exibirBairrosDisponiveis: false,
  limiteMinimoCompra: 0,
  logoMarca: '',
  logoFundo: '',
  tema: '',
  latitude: 0,
  longitude: 0,
  fusoHorario: 'America/Araguaina',
  ordenacaoProdutoValor: 0,
  diasAgendamento: null,
  mostrarEndereco: false,
  backgroundImage: 0,
  appThemeType: 'light',
  showCoupon: 1,
  minTimePickUp: '00:40',
  maxTimePickUp: '01:00',
  minTimeDelivery: '00:40',
  maxTimeDelivery: '01:00',
  tipoEntregaCheck: [],
  canSignUp: 1,
  orderNeighborhood: false,
  crossSelling: false,
  enablePaymentAsaas: false,
  sellOnlyWithLogin: false,
  layout: 0,
  requiredProofOfPayment: false,
  disableOrdersActions: false,
  hideAppPrice: false,
  notificationPushSong: 1,
  enableMostOrdered: false,
  cardapioVisualizacao: 0,
  verChamaGarcom: 0,
  endSessionAfterOrder: false,
  enableRequestBill: false,
  selectPizzaSizeFirst: false,
  enableRepeatOrder: false,
  identificationCustomer: false,
  enableProductSuggestions: true,
  requirePizzaBorder: false,
  seeCompleteProductComposition: true,
  disableOrdersTotal: false,
};
